import { TooltipProps } from './types'

export const Tooltip = ({
	showTooltip,
	title,
	isMenuOpen,
	tooltipPosition,
}: TooltipProps) => {
	if (!showTooltip || !title || isMenuOpen) return null

	return (
		<div
			role="tooltip"
			aria-hidden
			className="pointer-events-none fixed px-3 py-2 text-sm font-medium text-white bg-gray-900 rounded-lg shadow-lg z-[9999] dark:bg-gray-700 break-all w-fit max-w-[calc(100vw-10px)] mr-2"
			style={{
				top: tooltipPosition.top,
				left: tooltipPosition.left,
			}}
		>
			{title}
			<div className="pointer-events-none absolute -top-1 left-4 w-2 h-2 bg-gray-900 dark:bg-gray-700 transform rotate-45"></div>
		</div>
	)
}
